import * as React from 'react';
import {BrowserRouter as Router, Redirect, Route} from "react-router-dom";

import ContentFrameComponent from "../components/ContentFrameComponent/ContentFrameComponent";
import MainFrameComponent from "../components/MainFrameComponent/MainFrameComponent";
import SidebarComponent from "../components/SidebarComponent/SidebarComponent";
import TopbarComponent from "../components/TopbarComponent/TopbarComponent";

import {connect} from "react-redux";
import IRoute from "../interfaces/IRoute";
import routeList from '../routes';

export interface IMainProps {
    instanceID: string,
    sourcesCount: number,
}

class MainContainer extends React.PureComponent<IMainProps> {
    constructor(props: IMainProps) {
        super(props);

        this.defaultRoute = this.defaultRoute.bind(this);
    }

    public render() {
        const routes = routeList().map((route: IRoute) =>
            <Route key={route.name} path={route.url} component={route.component}/>);
        return (
            <Router basename="/literature-assistent">
                <TopbarComponent {...this.props}/>
                <MainFrameComponent>
                    <SidebarComponent {...this.props}/>
                    <ContentFrameComponent>
                        <Route path="/login" component={() => <Redirect to={this.defaultRoute()}/>}/>
                        {routes}
                    </ContentFrameComponent>
                </MainFrameComponent>
            </Router>
        );
    }

    private defaultRoute(): string {
        const routeUrls = routeList().map((r: IRoute) => r.url);
        return this.props.sourcesCount ? routeUrls[2] : routeUrls[0];
    }
}

const mapStateToProps = (store: any) => ({
    instanceID: store.credentials.instanceID,
    sourcesCount: store.literature.sources.length,
});

export default connect(mapStateToProps)(MainContainer);


// WEBPACK FOOTER //
// ./src/containers/MainContainer.tsx